import bootstrapTimepicker from 'angular-ui-bootstrap/src/timepicker';
import { timepickerComponent } from './timepicker.component';
import { timeLesserDirective } from './time-lesser.directive';
import './timepicker.scss';

export const timepicker = angular
    .module('common.components.timepicker', [
        bootstrapTimepicker
    ])
    .directive('timeLesser', timeLesserDirective)
    .component('timepicker', timepickerComponent)
    .run((defaultErrorMessageResolver) => {
        'ngInject';

        defaultErrorMessageResolver.getErrorMessages().then((errorMessages) => {
            errorMessages['hours'] = 'invalid hours';
            errorMessages['minutes'] = 'Invalid minutes';
            errorMessages['time'] = 'invalid time';
        });
    })
    .name;


// WEBPACK FOOTER //
// ./src/app/common/components/timepicker/timepicker.module.js